import { useEffect } from 'react'
import { UAParser } from 'ua-parser-js'
import { showMessage } from '../utils/snackbar'
import { useTranslation } from 'react-i18next'

export const useGenericAndroidKDetection = (): boolean => {
    const { t } = useTranslation()

    const ua = UAParser()
    const looksGenericAndroid =
        ua.os.name === 'Android' &&
        (ua.device.vendor?.includes('Generic') || ua.device.vendor === '') &&
        (ua.device.model === 'K' || ua.device.model === '')
    const isWebView = /; wv;/.test(navigator.userAgent) || /Version\/\d+\.\d+ Chrome\//.test(navigator.userAgent)
    const detected = looksGenericAndroid || isWebView

    useEffect(() => {
        if (detected) {
            showMessage(t('errors.restricted_browser_environment'), 'warning')
        }
        console.info('[useGenericAndroidKDetection] UAParser:', { ua })
    }, [detected, t, ua])

    return detected
}
